import { setCookie, getCookie, delCookie, forceInt, getCurrenLocaleObj, getUrlParameter } from '../functions';
import countdown from "countdown";

(function($) {
    // Scoped to the V2 giveaway's own entry page (CSSClassName set by
    // GiveawayV2PageController::enter()) so this never runs alongside
    // giveawayV2Page.js (.GiveawayV2Page, the ladder/dashboard page) or
    // giveawayPage.js (the V1 giveaway modal, excluded from this page in
    // Page.ss) even though all three modules are bundled together.
    const giveawayPage = $('.GiveawayV2Enter');
    if (!giveawayPage.length) return;

    const wrapperEnter = $('.js-giveaway-entry__wrapper-enter'),
        btnEnter = $('.js-giveaway-entry__wrapper-enter__btn'),
        wrapperEnterOptions = $('.js-giveaway-entry__wrapper-enter-options'),
        btnEnterWithEmail = $('.giveaway-entry__wrapper-enter-options__btn-enter-with-email'),
        wrapperFormWithEmail = $('.js-giveaway-entry__wrapper-form-with-email'),
        btnWithEmail = $('.js-giveaway-entry__wrapper-form-with-email__btn'),
        signUpForm = $('#SignUpForm_GiveawayV2SignUpForm'),
        signUpFormErrorMessageField = $('#SignUpForm_GiveawayV2SignUpForm_error'),
        signUpFormSubmitBtn = $('#SignUpForm_GiveawayV2SignUpForm_action_processSignUpForm'),
        wrapperSignedUp = $('.js-giveaway-signedup'),
        description = $('.js-giveaway-description'),
        giveawayId = forceInt(wrapperSignedUp.data('giveaway-id')),
        currenLocaleObj = getCurrenLocaleObj();

    const actionComplete = function(field) {
        if (field.hasClass('giveaway-signedup__actions-section__actions__action') && !field.hasClass('giveaway-signedup__actions-section__actions__action--complete')) {
            field.addClass('giveaway-signedup__actions-section__actions__action--complete')
                .find('.giveaway-signedup__actions-section__actions__action__status').html('');
        }
    };

    const updateEntriesCount = function() {
        let entriesCount = 0;
        const actionfields = $('.giveaway-signedup__actions-section__actions__action--complete');
        actionfields.each(function() {
            const $this = $(this),
                actionID = forceInt($(this).data('id'));

            const action = giveawayActions.find(action => action.ID === actionID);
            if (action) {
                entriesCount += forceInt(action.NumEntries);
            }
        });

        $('.js-giveaway-entires-count').text(entriesCount);
    };

    const updateEntries = function() {
        if (typeof giveawaySignUpEntries === 'object' && giveawaySignUpEntries && giveawaySignUpEntries.length) {
            giveawaySignUpEntries.forEach(entry => {
                const actionField = $('#giveaway-action-' + entry.ActionID);
                actionComplete(actionField);
            });
        }
    };

    // eventID matches the Conversions API event sent by SignUp::fireSignUpFbEvent() so FB can dedupe them
    const sendFBEvent = function(giveawayTitle, giveawayID, eventID) {
        if (window.FBPixelDefined) {
            fbq('track', 'CompleteRegistration', {
                content_name: 'Giveaway Signed Up',
                giveaway_name: giveawayTitle,
                giveaway_id: giveawayID
            }, (eventID ? { eventID: eventID } : {}));
        }
    };

    const sendGtmSignupEvent = function(giveawayTitle) {
        if (window.GtmDefined) {
            console.log(window.dataLayer);
            window.dataLayer.push({
                'event': 'giveawayEntry'
            });
        }
    };

    // Keep the form's own ReferralCode field (see SignUpForm::__construct())
    // in sync with the page's current "?rc=" query param - it's already
    // pre-filled server-side from the page's own initial querystring, but
    // this mirrors how Webflow's own site JS fills the "2jz-entry-form"
    // ReferralCode field before that form's own giveaway webhook submission
    // (see WebflowController::giveawayWebhookProcessBody()), so it stays
    // correct even if the field's server-rendered value is ever stale.
    const referralCodeFromUrl = getUrlParameter('rc');
    if (referralCodeFromUrl) {
        signUpForm.find('[name="ReferralCode"]').val(referralCodeFromUrl);
    }

    btnEnterWithEmail.on('click', function() {
        const $this = $(this);

        wrapperEnterOptions.hide();
        wrapperFormWithEmail.show();
    });

    if (signUpForm.length) {
        signUpForm.parsley().on('form:submit', function() {
            const $this = this.$element,
                formAction = $this.attr('action'),
                formData = $this.serialize();

            signUpFormErrorMessageField.hide();
            signUpFormSubmitBtn.attr('disabled', true);
            // Post to the form's own action rather than a hardcoded route -
            // GiveawayV2SignUpForm is bound to this page's own controller
            // (not a fixed cross-locale route like /giveaway-v2-controller/),
            // so its action URL is already correct for the current locale
            // and doesn't need an explicit giveawayId/?l= like that route does.
            $.post(formAction, formData, function(data) {
                let messages = '';
                if ('status' in data) {
                    if (data.status === 0) {
                        if (data.message !== '') {
                            messages = data.message;
                        }
                    } else if (data.status === 1) {
                        giveawaySignUpEntries = data.entries;
                        wrapperFormWithEmail.hide();
                        wrapperSignedUp.show();
                        $('.js-signup-name').text(data.name);
                        updateEntries();
                        updateEntriesCount();

                        // The referral panel (see GiveawayV2PageController::
                        // enter()) is rendered server-side from $SignUp,
                        // which doesn't exist yet for a brand new visitor -
                        // now that sign-up has just created one, fill in its
                        // referral URL from the AJAX response instead of
                        // needing a page reload.
                        if (data.referralUrl) {
                            $('.js-referral-link-copy')
                                .attr('data-copy-text', data.referralUrl)
                                .data('copyText', data.referralUrl)
                                .find('.giveaway-signedup__actions-section__actions__referral-panel__url')
                                .text(data.referralUrl);
                        }

                        // The Facebook CompleteRegistration event for an AJAX sign up is only sent server-side via
                        // the Conversions API (see SignUp::fireSignUpFbEvent()). The pixel was initialised before the
                        // email was known and ignores a second fbq('init'), so a pixel event here wouldn't have the
                        // email - and as it would reach FB first, the deduped server event (with the email) would be dropped.
                        if (data.sendSignupFBEvent) {
                            sendGtmSignupEvent();
                        }

                        if (description && description.length && !description.hasClass('giveaway-description--hide')) {
                            description.addClass('giveaway-description--hide');
                        }
                    }
                } else {
                    if (data && data.length) {
                        for (let n = 0, m = data.length; n < m; n++) {
                            const dataObject = data[n];
                            if (typeof dataObject === 'object' && 'message' in dataObject) {
                                if (dataObject.message) {
                                    if (messages !== '') messages += '<br>';
                                    messages += dataObject.message;
                                }
                            }
                        }
                    }
                }

                if (messages != '') {
                    signUpFormErrorMessageField.html(messages);
                    signUpFormErrorMessageField.show();
                }

                signUpFormSubmitBtn.removeAttr('disabled');
            }, 'json');

            return false;
        });
    }

    // The webinar action has no single URL to go to (see
    // GiveawayV2PageController::enter() and GiveawayV2Page::$webinar_options)
    // - instead of navigating or posting an entry, clicking it just
    // expands/collapses its own giveaway-signedup__actions-section__actions__webinar-list
    // panel, the same behaviour as the .js-giveaway-ladder-row--expandable
    // row on the ladder page (see giveawayV2Page.js).
    $('.giveaway-signedup__actions-section__actions__action').on('click touch', function () {
        const $this = $(this),
            actionID = forceInt($(this).data('id'));

        if ($this.hasClass('giveaway-signedup__actions-section__actions__action--expandable')) {
            const isExpanded = $this.attr('aria-expanded') === 'true';
            $this.attr('aria-expanded', String(!isExpanded));
            $('#' + $this.attr('aria-controls')).prop('hidden', isExpanded);
            return;
        }

        if (actionID) {
            const action = giveawayActions.find(action => action.ID === actionID);
            if (action) {
                if (action.Type === 'URL' && action.URL !== '') {
                    window.open(action.URL, '_blank');
                }

                if (!$this.hasClass('giveaway-signedup__actions-section__actions__action--complete')) {
                    // window.location.pathname
                    $.post('/giveaway-v2-controller/index/' + giveawayId + '/?l=' + currenLocaleObj.locale, { actionID: action.ID }, function(data) {
                        if (data.status === 1) {
                            giveawaySignUpEntries = data.entries;
                            actionComplete($this);
                            updateEntriesCount();
                        }
                    }, 'json');
                }
            }
        }
    });

    // -- Referral panel "copy" button ---------------------------------------
    // Copies the SignUp's referral URL (data-copy-text) via the Clipboard
    // API, falling back to a hidden-textarea + execCommand for browsers/
    // contexts without it (e.g. non-HTTPS) - ported from giveawayV2Page.js's
    // .js-referral-link-copy handler for the hub page's own referral link.
    // Lives inside the expandable referral panel (see
    // GiveawayV2PageController::enter()), so it's never a descendant of
    // .giveaway-signedup__actions-section__actions__action and won't
    // re-trigger that row's own expand/collapse click handler above.
    $('.js-referral-link-copy').on('click', function() {
        const $btn = $(this);
        const text = $btn.data('copyText');
        if (!text) return;

        const copyFallback = function() {
            const $temp = $('<textarea readonly>').val(text).css({ position: 'fixed', top: '-9999px' });
            $('body').append($temp);
            $temp[0].select();
            document.execCommand('copy');
            $temp.remove();
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).catch(copyFallback);
        } else {
            copyFallback();
        }

        const $labelText = $btn.find('.js-referral-link-label-text');
        clearTimeout($btn.data('copyResetTimeout'));
        $btn.addClass('is-copied');
        $labelText.text('Copied!');
        const resetTimeout = setTimeout(function() {
            $btn.removeClass('is-copied');
            $labelText.text('Copy link');
        }, 2000);
        $btn.data('copyResetTimeout', resetTimeout);
    });

    const giveawaySendSignupFBEvent = $('#giveaway-send-signup-fb-event');
    if (giveawaySendSignupFBEvent.length) {
        const giveawayTitle = giveawaySendSignupFBEvent.data('giveaway-title');
        sendFBEvent(giveawayTitle, forceInt(giveawaySendSignupFBEvent.data('giveaway-id')), giveawaySendSignupFBEvent.data('fb-event-id'));
        sendGtmSignupEvent();
    }

    updateEntries();

    // const $giveawayModal = $('#GiveawayModal');
    // if ($giveawayModal.length) {
    //     const $giveawayModalExit = $('.giveaway-modal-exit');
    //     $giveawayModalExit.on('click', function (e) {
    //         e.preventDefault();

    //         $giveawayModal.modal('hide');
    //     });
    // }

    // Giveaway modal
    // let $formSection = $('#giveaway-form');
    // let $congratulationsSection = $('#giveaway-congratulations');
    //
    // if ($congratulationsSection.css('display') !== 'none') {
    //     $formSection.css('display', 'none');
    // }
    //
    // let endDate = new Date($('#date-end').data('end')).getTime();
    //
    // let countdown = setInterval(function () {
    //     let now = new Date().getTime();
    //     let timeRemaining = endDate - now;
    //
    //     if (timeRemaining > 0) {
    //         let days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    //         let hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    //         let minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    //         let seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
    //
    //         days = days < 10 ? '0' + days : days;
    //         hours = hours < 10 ? '0' + hours : hours;
    //         minutes = minutes < 10 ? '0' + minutes : minutes;
    //         seconds = seconds < 10 ? '0' + seconds : seconds;
    //
    //         let timeString = days + ': ' + hours + ': ' + minutes + ':  ' + seconds;
    //         $('#giveaway-time-remaining').text(timeString);
    //     } else {
    //         clearInterval(countdown);
    //         $('#giveaway-time-remaining').text('The draw has ended.');
    //     }
    // }, 1000);
    //

})(jQuery);



// WEBPACK FOOTER //
// ./js/modules/giveawayV2Enter.js